import React from 'react';
import Markdown from 'react-remarkable';
import GlobeChart from '../GlobeChart/GlobeChart.jsx';
import {contentToText} from '../../../utils/helpers.jsx';
import content from '../../../../content/main.archie';
import Inset from '../../Inset/Inset.jsx';
import SubInset from '../../SubInset/SubInset.jsx';
import _ from 'lodash';
const focusOffset=120;

function getDataUri(url, callback) {
    var image = new Image();

    image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
        canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size

        canvas.getContext('2d').drawImage(this, 0, 0);

        // Get raw image data
        callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''));

        // ... or get as Data URI
        callback(canvas.toDataURL('image/png'));
    };

    image.src = url;
}


function getGlobeIndex(cardidx) {
    let retidx = 0;
    if(cardidx>0) {
        if(cardidx<data.length) {
            retidx = cardidx;
        } else {
            retidx = data.length -1;
        }
    } 
    return retidx;
}

const CoralSource = (props) => {
    return <div className="box source smart-underline-back">
        Source: UNEP-WCMC (<a href="javascript:void(0)" onClick={() => document.querySelector("#coralsourcepopup").classList.add('visible')}>see full source</a>)
    </div>   
}
const CoralWidget = (props) => {
    return <div id="coralsourcepopup" className="overlay inset-text">
        <div className="popup">
            <a className="close" href="javascript:void(0)" onClick={() => document.querySelector("#coralsourcepopup").classList.remove('visible')}>×</a>
            <div className="content smart-underline-white">
                <img src="images/UNEP-WCMC.jpg" style={{float:"left",marginRight:"15px",marginBottom:"15px",width:"110px"}} />
                UNEP-WCMC, WorldFish Centre, WRI, TNC (2010). Global distribution of coral reefs, compiled from multiple sources including the Millennium Coral Reef Mapping Project. Version 1.3, updated by UNEP-WCMC. Includes contributions from IMaRS-USF and IRD (2005), IMaRS-USF (2005) and Spalding et al. (2001). Cambridge (UK): UNEP World Conservation Monitoring Centre. URL: <a href="http://data.unep-wcmc.org/datasets/1">http://data.unep-wcmc.org/datasets/1</a>
                <br/><br/>
                Visit Ocean Data Viewer here: <a className="smart-underline-white" href="http://wcmc.io/ODV">http://wcmc.io/ODV</a>
            </div>
        </div>
    </div>
}



function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

const MapButton = (props) => (<div className="btn waves-effect waves-light" onClick={props.onClick}>{props.children}</div>);

const MapButtons = (props) => {
    return <div className="mapbuttons">
        {data.map((obj,i) => <MapButton key={"mapbutton_"+i} onClick={() => props.onSelect(i)} key={"mapbutton_"+i}>{obj.buttonTitle}</MapButton>)}
    </div>;
}

const StandardCard = (props) => {
    return <div className={"globe-card card-panel" + (props.selected?" selected-card":" unselected-card")} style={{zIndex:100,pointerEvents:"initial"}}>
        <span>
            <div className="card-title">{props.title}</div>
            <Markdown>
                {props.content}
            </Markdown>
        </span>
    </div>}; 

const Spacer = (props) => <div style={{width:"100%",height:props.height+"px",visibility:"hidden",pointerEvent:"none",display:"block"}}/>;

const GradientWidget = (props) => <div style={{textAlign:"center", display:"table", marginTop:"10px"}}>
            <span style={{display:"table-cell", whiteSpace: "nowrap"}}>{props.lowLabel}</span>
            <span style={{
                        width: "100%",
                        display: "table-cell",
                        paddingLeft:"5px",
                        paddingRight:"5px"
                    }}>
                <span style={{
                        width: "100%",
                        height: "20px",
                        display: "inline-block",
                        verticalAlign:"middle",
                        background: "linear-gradient(to right,"+props.gradient+ ")"
                    }}></span>
            </span>
            <span style={{display:"table-cell", whiteSpace: "nowrap"}}>{props.highLabel}</span>
        </div>;

const data = [
    {
        title: "Worldwide shipping traffic",
        image: "images/trafficmap.jpg",  
        source: "Source: NCEAS 2013 Global Assessment of Cumulative Human Impacts on the Ocean",
        legend: <GradientWidget lowLabel="Low traffic" highLabel="High traffic" gradient="#2b83ba,#abdda4,#ffffbf,#fdae61,#d7191c" />,
        buttonTitle:"Traffic"
    },
    {
        title: "Incidence of invasive species",
        image:"images/invasives.jpg",
        source: "Source: NCEAS 2013 Global Assessment of Cumulative Human Impacts on the Ocean (Averaged over two degree hex grid)",
        legend: <GradientWidget lowLabel="Low incidence" highLabel="High indicidence" gradient="#2b83ba,#abdda4,#ffffbf,#fdae61,#d7191c" />,
        buttonTitle:"Invasives"
    },
    {
        title: "Ocean acidification",
        image:"images/acidmap.jpg",
        source: "Source: NCEAS 2013 Global Assessment of Cumulative Human Impacts on the Ocean",
        legend: <GradientWidget lowLabel="Low acidity" highLabel="High acidity" gradient="#2b83ba,#abdda4,#ffffbf,#fdae61,#d7191c" />,
        buttonTitle:"Acidification"
    },
    {
        title: "Locations of coral reefs",
        image:"images/corals.jpg",
        source: <CoralSource />,
        legend: <div><span className="coralcolor" /> = Coral reef</div>,
        buttonTitle:"Corals"
    },
    {
        title: "Environmental stress on the oceans",
        image:"images/oceanstress.jpg",
        source: "Source: NCEAS 2013 Global Assessment of Cumulative Human Impacts on the Ocean",
        legend: <GradientWidget lowLabel="Low stress" highLabel="High stress" gradient="#2b83ba,#abdda4,#ffffbf,#fdae61,#d7191c" />,
        buttonTitle:"Stress"
    }
];



let firstUpdate = true;
export default class GlobeStory extends React.Component {
    constructor() {
        super(arguments);
        this.state = {
            globeFixed: false,
            fixedSize:null,
            unfixedPos:0,
            currentCard:0,
            currentMap:0,
            spacerHeight:0
        }
        this.onMapSelect = this.onMapSelect.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this._handleScroll = _.throttle(this.handleScroll,10);
    }
    componentDidMount() {
        window.addEventListener('scroll', this._handleScroll);
        
        setTimeout(() => data.forEach((datum) => {
            getDataUri(datum.image,(dataUri) => {
                datum.image = dataUri;    
            });    
        }),10000);
        
        
        
        
    }
    handleScroll() {
        let modehinter = this.refs.modehinter;
        let narrowmode = getComputedStyle(modehinter,null).display==="none";
        let globecol = this.refs.globecol;
        let cardcol = this.refs.cardchannel;
        let sizegiver = this.refs.sizegiver;
        let sp = window.scrollY;//prevcontext.scrollPos;
        let cards = Array.from(cardcol.querySelectorAll(".globe-card"));
        if(cards.length == 0) { return; }
        let cardboffsets = cards.map((card) => offset(card).top + card.getBoundingClientRect().height);
        
        let abovecards = cardboffsets.filter((val) => ((val - (narrowmode?0:this.context.winHeight/2)) < sp));
        let curcardidx =  Math.min(abovecards.length,cards.length-1);
        let lastcard = cards[cards.length-1];
        let topfix = offset(this.refs.globecol).top;//offset(cardcol).top;
        let bottomfix = narrowmode?(offset(lastcard).top+lastcard.getBoundingClientRect().height):offset(lastcard).top;
        let bottomspacer = this.refs.bottomspacer;
        let isBelowTop = sp > topfix-focusOffset;
        let isAboveBottom = sp<bottomfix-focusOffset;
        let shouldBeFixed = isBelowTop && isAboveBottom;
        let globe = this.refs.globechart;
        let prevFixed = globe.style.position == "fixed";
        
        
        if(shouldBeFixed && !prevFixed) {
            this.setState({globeFixed:true,currentCard:curcardidx, currentMap:curcardidx});
        }
        else if(!shouldBeFixed && prevFixed) {
            
            if(isAboveBottom) {
                
                this.setState({globeFixed:false, unfixedPos:0, currentCard:curcardidx,currentMap:curcardidx});
            } else {
                
                this.setState({globeFixed:false, unfixedPos:bottomfix-topfix, currentCard:curcardidx});
            }
        } else if(curcardidx != this.state.currentCard) {
            
            this.setState({currentCard:curcardidx,currentMap:curcardidx});    
        }
        if(this.state.fixedSize == null) {
            this.setState({fixedSize:sizegiver.getBoundingClientRect().width});
        }
        
        /*if(winwidthchanged || this.state.narrowMode != prevstate.narrowMode || firstUpdate) {
            if(this.state.narrowMode) {
                cards.forEach((card,i) => card.style.marginTop = globeHeight+"px");
                bottomspacer.style.height = 0;    
            } else {
                bottomspacer.style.height = Math.max(globeHeight - lastcard.getBoundingClientRect().height,0)+"px";
                cards.forEach((card,i) => card.style.marginTop = 0);
            }
            firstUpdate = false;
        }*/
         //globe.style.transform = "translate(0,"+Math.max(sp - offset(cardcol).top,0)+"px)";   
    }
    componentDidUpdate(prevprops,prevstate,prevcontext) {
        
        let modehinter = this.refs.modehinter;
        let globe = this.refs.globechart;
        let globeHeight = globe.getBoundingClientRect().height;
        let desiredSpacerHeight;
        let sizegiver = this.refs.sizegiver;
        if(getComputedStyle(modehinter,null).display=="none") {
            desiredSpacerHeight = window.innerHeight*0.9;    
        } else {
            desiredSpacerHeight = 0;
        }
        
        if(this.state.spacerHeight != desiredSpacerHeight) {
            this.setState({spacerHeight:desiredSpacerHeight});
            return;
        }
        
        if(prevcontext.winWidth != this.context.winWidth) {
            this.setState({fixedSize:sizegiver.getBoundingClientRect().width});    
        }
        
        
        
        
        //let winwidthchanged = this.context.winWidth!=prevcontext.winWidth;
        
        
    }
    onMapSelect(index) {
        this.setState({currentMap:index})    
    }
    render() {
        const componentRegistry = {
            mapbuttons:<MapButtons onSelect={this.onMapSelect} />
        }
        
        return <div ref="globestory" className="container">
            <Inset hed="Fragile Globe" dek="How shipping impacts the world's ecosystems" source="Land imagery: NASA’s Earth Observatory"> 
                <div className="section">
                    <div className="row">
                        <div ref="globecol" className="col l6 m6 s12" style={{zIndex:0,position:"relative"}}>
                            <div ref="sizegiver" style={{width:"100%",height:"1px"}}></div>
                            <div ref="modehinter" className="hide-on-small-and-down"></div>
                            
                            <div ref="globechart" className="inset-text" style={{
                                position:this.state.globeFixed?"fixed":"absolute",
                                width:this.state.globeFixed?this.state.fixedSize:"calc(100% - 1.5rem)",
                                top:this.state.globeFixed?focusOffset+"px":this.state.unfixedPos+"px",
                                zIndex:0
                            }}>
                                <SubInset 
                                    hed={data[getGlobeIndex(this.state.currentMap)].title}
                                    source={data[getGlobeIndex(this.state.currentMap)].source}
                                    notes={data[getGlobeIndex(this.state.currentMap)].notes}
                                >
                                    <GlobeChart 
                                        texture={data[getGlobeIndex(this.state.currentMap)].image}
                                        legend={data[getGlobeIndex(this.state.currentMap)].legend}
                                        flat={false}
                                        />
                                </SubInset>
                            </div>
                        </div>
                        <div ref="cardchannel" className="col l6 m6 s12" style={{zIndex:1,position:"relative",pointerEvents:"none"}}>
                            {content.globecards.map((obj,i) => {  
                                return <div key={"cardcont_"+i}>
                                    <Spacer height={this.state.spacerHeight}/>
                                    <StandardCard 
                                        key={"card_"+i} 
                                        title={obj.title}
                                        content={contentToText(obj.content,componentRegistry)} 
                                        selected={i==this.state.currentCard}
                                    />
                                </div>
                            })}
                            <Spacer height={Math.max(this.state.spacerHeight,400)}/>
                        </div>
                        
                    </div>
                </div>
            </Inset>
            <CoralWidget/>
        </div>            
    }
}
GlobeStory.contextTypes = {
    //scrollPos: React.PropTypes.number.isRequired,
    winWidth: React.PropTypes.number.isRequired,
    winHeight: React.PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/js/components/special/GlobeStory/GlobeStory.jsx